(() => {
  document.documentElement.classList.add('oneshot-collection-js');

  const selector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
  ].join(',');

  function initCollection() {
    document.querySelectorAll('[data-oneshot-sort-form]').forEach((form) => {
      if (form.dataset.oneshotReady === 'true') return;
      form.dataset.oneshotReady = 'true';
      form.querySelector('[data-oneshot-sort-select]')?.addEventListener('change', () => {
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }
      });
    });

    document.querySelectorAll('link[data-oneshot-pagination-head-link]').forEach((link) => {
      document.head.append(link);
    });

    const toggle = document.querySelector('[data-oneshot-filter-toggle]');
    const drawer = document.querySelector('[data-oneshot-filter-drawer]');
    const closeButton = document.querySelector('[data-oneshot-filter-close]');
    const scrim = document.querySelector('[data-oneshot-filter-scrim]');
    if (!toggle || !drawer || !closeButton || !scrim || drawer.dataset.oneshotReady === 'true') return;

    drawer.dataset.oneshotReady = 'true';
    const mobileQuery = window.matchMedia('(max-width: 999px)');
    let returnFocus = toggle;

    const focusableElements = () =>
      Array.from(drawer.querySelectorAll(selector)).filter(
        (element) => !element.hasAttribute('hidden') && element.getClientRects().length > 0
      );

    const closeDrawer = ({ restoreFocus = true } = {}) => {
      drawer.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      scrim.hidden = true;
      document.documentElement.classList.remove('oneshot-collection-drawer-open');
      if (mobileQuery.matches) {
        drawer.setAttribute('aria-hidden', 'true');
        drawer.inert = true;
      }
      if (restoreFocus && mobileQuery.matches) returnFocus?.focus();
    };

    const openDrawer = () => {
      if (!mobileQuery.matches) return;
      returnFocus = document.activeElement instanceof HTMLElement ? document.activeElement : toggle;
      drawer.inert = false;
      drawer.removeAttribute('aria-hidden');
      drawer.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      scrim.hidden = false;
      document.documentElement.classList.add('oneshot-collection-drawer-open');
      closeButton.focus();
    };

    const syncMode = () => {
      if (mobileQuery.matches) {
        drawer.setAttribute('role', 'dialog');
        drawer.setAttribute('aria-modal', 'true');
        if (!drawer.classList.contains('is-open')) {
          drawer.setAttribute('aria-hidden', 'true');
          drawer.inert = true;
          scrim.hidden = true;
        }
      } else {
        drawer.classList.remove('is-open');
        drawer.removeAttribute('role');
        drawer.removeAttribute('aria-modal');
        drawer.removeAttribute('aria-hidden');
        drawer.inert = false;
        toggle.setAttribute('aria-expanded', 'false');
        scrim.hidden = true;
        document.documentElement.classList.remove('oneshot-collection-drawer-open');
      }
    };

    toggle.addEventListener('click', openDrawer);
    closeButton.addEventListener('click', () => closeDrawer());
    scrim.addEventListener('click', () => closeDrawer());

    document.addEventListener('keydown', (event) => {
      if (!mobileQuery.matches || !drawer.classList.contains('is-open')) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeDrawer();
        return;
      }
      if (event.key !== 'Tab') return;

      const focusable = focusableElements();
      if (focusable.length === 0) {
        event.preventDefault();
        drawer.focus();
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (!drawer.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      } else if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    mobileQuery.addEventListener('change', syncMode);
    syncMode();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollection, { once: true });
  } else {
    initCollection();
  }

  document.addEventListener('shopify:section:load', initCollection);
})();
